/* eslint-disable
    no-shadow,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import * as CRISPRUtil from 'molbio/crispr/CRISPRUtil';

const {isLeftPam} = CRISPRUtil;

import * as sequtil from 'molbio/SeqUtil';

function highlightMutant(original, mutated, index, targetSite, pam) {
  const pamOnRight =
    (targetSite.strand === 1 && !isLeftPam(pam)) || (targetSite.strand === -1 && isLeftPam(pam));

  function inPAMSite(index) {
    if (pamOnRight) {
      return sequtil.baseInRange(index, targetSite.end - pam.length, targetSite.end);
    } else {
      return sequtil.baseInRange(index, targetSite.start, targetSite.start + pam.length);
    }
  }

  const inTargetSite = (index) => sequtil.baseInRange(index, targetSite.start, targetSite.end);

  // eslint-disable-next-line no-restricted-syntax
  return _.map(_.zip(original, mutated), (...args) => {
    const [o, m] = Array.from(args[0]),
      j = args[1];
    return (
      <span
        key={`char-${o}-${m}-${j}`}
        className={
          !inTargetSite(index + j)
            ? 'text-muted'
            : o !== m
              ? 'text-danger'
              : inPAMSite(index + j)
                ? 'text-primary'
                : ''
        }
      >
        {m}
      </span>
    );
  });
}

export default highlightMutant;
